import { render, staticRenderFns } from "./DaysList.vue?vue&type=template&id=61098a44&"
import script from "./DaysList.vue?vue&type=script&lang=js&"
export * from "./DaysList.vue?vue&type=script&lang=js&"
import style0 from "./DaysList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports